"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceSettings = _interopRequireDefault(require("../../ServiceSettings"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

var _ikeaSharedLocales = _interopRequireDefault(require("@ikea-aoa/ikea-shared-locales"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var APP_INFO = _UrlUtility.default.getAppInfo();
/**
 * This class handles fetching of localization data.
 */


var LocalizationService = /*#__PURE__*/function (_AbstractService) {
  _inherits(LocalizationService, _AbstractService);

  var _super = _createSuper(LocalizationService);

  function LocalizationService() {
    _classCallCheck(this, LocalizationService);

    return _super.apply(this, arguments);
  }

  _createClass(LocalizationService, [{
    key: "getLocales",

    /**
     * Returns the available locales.
     *
     * @return {Object} Locales as key value pairs.
     */
    value: function getLocales() {
      return _ikeaSharedLocales.default;
    }
    /**
     * Returns localizations.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "getData",
    value: function getData() {
      return Promise.all([this._getCommonMasterLocalization(), this._getCommonLocalization(), this._getAppMasterLocalization(), this._getAppLocalization()]).then(function (responses) {
        var mergedLocalization = Object.assign.apply(Object, [{}].concat(_toConsumableArray(responses)));

        for (var _i = 0, _Object$keys = Object.keys(mergedLocalization); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          mergedLocalization[key] = Object.assign({}, responses[0][key], responses[1][key], responses[2][key], responses[3][key]);
        }

        mergedLocalization.translations = mergedLocalization.translations || {};
        mergedLocalization.apiLocalePath = mergedLocalization.localization ? mergedLocalization.localization.iowsLocalePath || mergedLocalization.localization.countryCode + '/' + mergedLocalization.localization.languageCode : null;
        return mergedLocalization;
      });
    }
    /**
     * Returns common localizations.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "_getCommonLocalization",
    value: function _getCommonLocalization() {
      var _this = this;

      if (!_ServiceSettings.default.commonLocalization) {
        throw new _ServiceException.default('Failed to get localizations. "ServiceSettings.commonLocalization" is not defined.', this.constructor.factoryName);
      }

      return new Promise(function (resolve, reject) {
        if (typeof _ServiceSettings.default.commonLocalization === 'string') {
          var url = _ServiceSettings.default.commonLocalization.replace('{country}', APP_INFO.country).replace('{language}', APP_INFO.language);

          fetch(url, {
            credentials: 'same-origin'
          }).then(_this._handleJsonResponse.bind(_this)).then(resolve).catch(_this._rejectWrapper.bind(_this, reject));
        } else {
          setTimeout(resolve.bind(null, _ServiceSettings.default.commonLocalization));
        }
      });
    }
    /**
     * Returns app localizations.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "_getAppLocalization",
    value: function _getAppLocalization() {
      var _this2 = this;

      if (typeof _ServiceSettings.default.appLocalization === 'string' && !_ServiceSettings.default.applicationName) {
        throw new _ServiceException.default('Failed to get app localizations. "ServiceSettings.applicationName" is not defined.', this.constructor.factoryName);
      }

      return new Promise(function (resolve, reject) {
        if (typeof _ServiceSettings.default.appLocalization === 'string') {
          var url = _ServiceSettings.default.appLocalization.replace('{applicationName}', _ServiceSettings.default.applicationName).replace('{country}', APP_INFO.country).replace('{language}', APP_INFO.language);

          fetch(url, {
            credentials: 'same-origin'
          }).then(_this2._handleJsonResponse.bind(_this2)).then(resolve).catch(_this2._rejectWrapper.bind(_this2, reject));
        } else {
          setTimeout(resolve.bind(null, _ServiceSettings.default.appLocalization || {}));
        }
      });
    }
    /**
     * Returns common master localization.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "_getCommonMasterLocalization",
    value: function _getCommonMasterLocalization() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (typeof _ServiceSettings.default.commonMasterLocalization === 'string') {
          var url = _ServiceSettings.default.commonMasterLocalization.replace('{country}', APP_INFO.country).replace('{language}', APP_INFO.language);

          fetch(url, {
            credentials: 'same-origin'
          }).then(_this3._handleJsonResponse.bind(_this3)).then(resolve).catch(_this3._rejectWrapper.bind(_this3, reject));
        } else {
          setTimeout(resolve.bind(null, _ServiceSettings.default.commonMasterLocalization || {}));
        }
      });
    }
    /**
     * Returns application master localization.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "_getAppMasterLocalization",
    value: function _getAppMasterLocalization() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        if (typeof _ServiceSettings.default.appMasterLocalization === 'string') {
          var url = _ServiceSettings.default.appMasterLocalization.replace('{applicationName}', _ServiceSettings.default.applicationName).replace('{country}', APP_INFO.country).replace('{language}', APP_INFO.language);

          fetch(url, {
            credentials: 'same-origin'
          }).then(_this4._handleJsonResponse.bind(_this4)).then(resolve).catch(_this4._rejectWrapper.bind(_this4, reject));
        } else {
          setTimeout(resolve.bind(null, _ServiceSettings.default.appMasterLocalization || {}));
        }
      });
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'localization';
    }
  }]);

  return LocalizationService;
}(_AbstractService2.default);

exports.default = LocalizationService;